export const LEVEL_CLASSES = [
  'activity-map__cell--level-0',
  'activity-map__cell--level-1',
  'activity-map__cell--level-2',
  'activity-map__cell--level-3',
  'activity-map__cell--level-4',
];

export const aggregateTotalsByIndex = (data) => {
  const totalsByIndex = [];
  if (Array.isArray(data)) {
    data.forEach((course) => {
      const engArr = course?.engagement;
      if (Array.isArray(engArr)) {
        engArr.forEach((val, i) => {
          totalsByIndex[i] = (totalsByIndex[i] || 0) + (val || 0);
        });
      }
    });
  }
  return totalsByIndex;
};

export const normalizeEngagement = (data, startDate, numDays) => {
  const totalsByIndex = [];

  if (Array.isArray(data)) {
    data.forEach((course) => {
      const engArr = course?.engagement;
      if (Array.isArray(engArr)) {
        engArr.forEach((val, i) => {
          totalsByIndex[i] = (totalsByIndex[i] || 0) + (val || 0);
        });
      }
    });
  }

  const maxVal = totalsByIndex.length > 0 ? Math.max(...totalsByIndex, 1) : 1;

  const start = new Date(startDate);
  const days = [];

  const len = numDays || totalsByIndex.length || 30;
  for (let i = 0; i < len; i++) {
    const current = new Date(start);
    current.setDate(current.getDate() + i);
    const dateStr = current.toISOString().slice(0, 10);
    const raw = totalsByIndex[i] || 0;

    let level = 0;
    if (raw > 0 && maxVal > 0) {
      const ratio = raw / maxVal;
      if (ratio <= 0.25) level = 1;
      else if (ratio <= 0.5) level = 2;
      else if (ratio <= 0.75) level = 3;
      else level = 4;
    }
    days.push({ date: dateStr, level });
  }

  return days;
};

export const formatTooltipDate = (dateStr, locale) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString(locale || undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

// Localized short weekday names indexed by Date.getDay() (0=Sunday .. 6=Saturday).
// 2023-01-01 is a Sunday, so iterating from it yields names in getDay() order.
export const getWeekdayShortNames = (locale) => {
  const fmt = new Intl.DateTimeFormat(locale || undefined, { weekday: 'short' });
  return Array.from({ length: 7 }, (_, i) => fmt.format(new Date(2023, 0, 1 + i)));
};
